import { Trans, useTranslation } from 'react-i18next';
import { Button, ModalComponentWrapper } from '@/shared/components';
import { InvoiceDetailsContent } from './InvoiceDetailsContent';
import {
  type InvoiceDetailsModalProps,
  useInvoiceDetails,
} from '@/features/deposit-bank-transfer';
import { cn } from '@/shared/utils';

export function InvoiceDetailsModal({
  mode,
  invoiceData,
  onBack,
  onDeleted,
}: InvoiceDetailsModalProps) {
  const { t } = useTranslation();
  const {
    isLoading,
    isError,
    error,
    handleSubmitButtonClick,
    fileName,
    onDownload,
    onPrint,
    ConfirmationModal,
    fileSizeStr,
    invoiceDetails,
  } = useInvoiceDetails(invoiceData, mode, onDeleted);

  const title =
    mode === 'new'
      ? t('depositMethods.bankTransfer.invoiceDetails.newTitle')
      : t('depositMethods.bankTransfer.invoiceDetails.viewTitle');
  const buttonText =
    mode === 'new'
      ? t('depositMethods.bankTransfer.invoiceDetails.done')
      : t('depositMethods.bankTransfer.invoiceDetails.delete');
  const description = (
    <Trans
      i18nKey={
        mode === 'new'
          ? 'depositMethods.bankTransfer.invoiceDetails.description'
          : 'depositMethods.bankTransfer.invoiceDetails.viewDescription'
      }
      components={{ accent: <span className="text-primary" /> }}
    />
  );

  const handleClick = () => {
    handleSubmitButtonClick();
  };

  return (
    <ModalComponentWrapper
      title={title}
      description={description}
      descriptionClassName="p4 text-muted-foreground"
      onBack={onBack}
      footer={
        <Button
          type="submit"
          variant="secondary"
          size="lg"
          disabled={isLoading}
          loading={isLoading}
          onClick={handleClick}
          className={cn('w-full')}>
          {buttonText}
        </Button>
      }>
      <InvoiceDetailsContent
        invoiceDetails={invoiceDetails}
        isError={isError}
        error={error}
        isLoading={isLoading}
        fileName={fileName}
        fileSizeStr={fileSizeStr}
        onDownload={onDownload}
        onPrint={onPrint}
        ConfirmationModal={ConfirmationModal}
      />
    </ModalComponentWrapper>
  );
}
